module.exports = __webpack_public_path__ + "static/media/logo.688ed841.svg";